var riot = require('riot');
module.exports = riot.tag2('item-view', '<div class="view item-view" show="{items.length}"> <item class="item" each="{items}" data="{this}"></item> <ul class="poll-options" if="{pollOptions}"> <li each="{pollOptions}"> <p>{text}</p> <p class="subtext">{score} points</p> </li> </ul> <ul class="comments"> <div each="{c, i in comments}"> <comment data="{c}"></comment> </div> </ul> <p show="{!comments.length}">No comments yet.</p> </div>', '', '', function(opts) {
  require('../components/item.html')
  require('../components/comment.html')
  var store = require('../store')
  var self = this
  self.items = []

  this.fetchComments = function() {
    store.fetchItems(self.items[0].kids, function (comments) {
      self.comments = comments
      self.update()
    })
  }.bind(this)

  this.fetchPollOptions = function() {
    store.fetchItems(self.items[0].parts, function (options) {
      self.pollOptions = options
      self.update()
    })
  }.bind(this)

  store.fetchItem(opts.data, function (item) {
    self.items = [ item ]
    self.fetchComments()
    if (item.type === 'poll') {
      self.fetchPollOptions()
    }
    self.update()
  })
}, '{ }');
